import { Theme } from '@mui/material/styles'
export const tableStyles = {
  header: {
    fontSize: '14px',
    fontFamily: 'Source Sans Pro Semibold',
  },

  manageLink: {
    fontSize: '14px',
    color: '#1768ab',
  },

  footerCell: { padding: (theme: Theme) => theme.spacing(0) },

  footerContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  loading: { flexGrow: 1 },
  pagination: { marginLeft: 'auto' },
}
